// extracted by mini-css-extract-plugin
export default {"shopping-cart":"cart_shopping-cart__t6od2","cart-icon":"cart_cart-icon__KMfvU","counter":"cart_counter__8A+vq"};